import React from 'react';

import { Flex } from '@chakra-ui/react';

import { CustomText } from '@components/Custom-text';
import NavItem from '@components/nav-section/horizontal/NavItem';
import { paths } from '@routes/path';

interface AuthFooterProps {
    isRelative?: boolean;
}

const AuthFooter = ({ isRelative = false }: AuthFooterProps) => (
    <Flex
        position={isRelative ? 'relative' : 'absolute'}
        bottom={0}
        gap={4}
        width="100%"
        justifyContent="center"
        alignSelf="end"
        pb={8}
    >
        <NavItem title="Terms & Conditions" path={paths.general.termsandconditions} />
        <CustomText color="titleText">|</CustomText>
        <NavItem title="Privacy Policy" path={paths.general.privacy} />
    </Flex>
);

export default AuthFooter;
